import Vue from "vue";
import Router, {RouterOptions, RouteConfig} from "vue-router";
import VueRouter from "vue-router";

import Map from '@/view/Map.vue';
import MapTest from '@/view/MapTest.vue';
import Exhibitions from '@/view/Exhibitions.vue';
import Dashboard from '@/view/Dashboard.vue'
import Control from '@/view/Control.vue';
import Exhibition from '@/view/Exhibition.vue';
// import {checkNotAuthenticated} from '../../../lfs-web/src/router/guards';
import AuthLayout from '@/components/auth/Layout.vue';
import SignIn from '@/components/auth/SignIn.vue';

import {checkNotAuthenticated, checkAuthenticated} from "./guards";
import Events from '@/view/Events.vue';
import Event from '@/view/Event.vue';
import PageNotFound from '@/view/PageNotFound.vue';
import Company from '@/view/Company.vue';
import Notifications from '@/view/Notifications.vue';
import Support from '@/view/Support.vue';
import MapView from '@/view/MapView.vue';
import Report from "@/components/lfs/Statistics/pdf/Report.vue";
import Logout from "@/components/lfs/Logout.vue";


Vue.use(Router);

const routes: RouteConfig[] = [
    {
        path: "/logout",
        name: "Logout",
        component: Logout,
        meta: {layout: 'None'},
    },
    {
        path: "/auth",
        name: "Auth",
        component: AuthLayout,
        redirect: {name: "Signin"},
        beforeEnter: (to, from, next) => {
            checkNotAuthenticated(to, from, next).then(() => {
                next();
            });
        },
        children: [
            {
                path: "signin",
                name: "Signin",
                component: SignIn,
                meta: {layout: 'none'},
            },
        ],
    },
    {
        path: "/",
        name: "Home",
        component: AuthLayout,
        redirect: {name: "Events"},
    },
    {
        path: "*",
        redirect: {name: "Home"}
    },
    {
        path: "/map",
        name: "Map",
        component: Map,
        meta: {layout: 'None'},
    },
    {
        path: "/mapview/:code",
        name: "MapView",
        component: MapView,
        meta: {layout: 'None'},
    },
    {
        path: "/map-edit/:event/:code",
        name: "MapEdit",
        component: MapTest,
        meta: {layout: 'None'},
        beforeEnter: (to, from, next) => {
            checkAuthenticated(to, from, next).then(() => {
                next();
            });
        },
    },
    {
        path: "/events",
        name: "Events",
        component: Events,
        meta: {layout: 'Admin'},
        beforeEnter: (to, from, next) => {
            checkAuthenticated(to, from, next).then(() => {
                next();
            });
        },
    },
    {
        path: "/events/:slug",
        name: "Event",
        component: Event,
        meta: {
            layout: 'Admin'
        },
        beforeEnter: (to, from, next) => {
            checkAuthenticated(to, from, next).then(() => {
                next();
            });
        },
    },
    {
        path: "/events/:event/:exhibition",
        name: "Exhibition",
        component: Exhibition,
        meta: {layout: 'Admin'},
        beforeEnter: (to, from, next) => {
            checkAuthenticated(to, from, next).then(() => {
                next();
            });
        },
    },
    {
        path: "/events/:event/:exhibition/:company",
        name: "Company",
        component: Company,
        meta: {layout: 'Admin'},
        beforeEnter: (to, from, next) => {
            checkAuthenticated(to, from, next).then(() => {
                next();
            });
        },
    },
    {
        path: "/notifications",
        name: "Notifications",
        component: Notifications,
        meta: {layout: 'Admin'},
        beforeEnter: (to, from, next) => {
            checkAuthenticated(to, from, next).then(() => {
                next();
            });
        },
    },
    {
        path: "/support",
        name: "Support",
        component: Support,
        meta: {layout: 'Admin'},
        beforeEnter: (to, from, next) => {
            checkAuthenticated(to, from, next).then(() => {
                next();
            });
        },
    },
    {
        path: "/exhibitions",
        name: "Exhibitions",
        component: Exhibitions,
        meta: {layout: 'Admin'},
        beforeEnter: (to, from, next) => {
            checkAuthenticated(to, from, next).then(() => {
                next();
            });
        },
    },
    {
        path: "/dashboard",
        name: "Dashboard",
        component: Dashboard,
        meta: {layout: 'Admin'}
    },
    {
        path: "/control",
        name: "Control",
        component: Control,
        meta: {layout: 'Admin'},
    },
    {
        path: '/pdf',
        name: 'Pdf',
        component: Report,
        meta: {layout: 'Admin'}
    },
    {path: "*", component: PageNotFound},

    // {
    //   path: "/new",
    //   name: "SignIn",
    //   component: SignIn,
    //   meta: {layout: 'none'},
    // },


];

const options: RouterOptions = {
    mode: "history",
    base: process.env.BASE_URL,
    routes,
};

const router = new VueRouter(options);

export default router;
